var render = function render(){var _vm=this,_c=_vm._self._c;return _c('website-page',{staticClass:"cms-page-blocks",class:{ 'preview': _vm.preview }},[_c('preview-responsive-container',[_c('cms-block-builder',{attrs:{"blocks":_vm.cmsPage.blocks}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }